<template>
    <div class="container-fluid">
        <div class="incidentORIheader mb-3">
            <div class="left">
                <label>{{ headerLeftLabel }}</label>
            </div>
            <div class="right">
                <label>{{ headerRightLabel }}</label>
            </div>
        </div>
        <ul class="nav nav-tabs">
            <li class="nav-item" v-for="tab in tabs">
                <a class="nav-link" :class="{ 'active': isActive(tab.componentName) }" aria-current="true" href="#"
                    @click.prevent="setActiveTab(tab.componentName)">{{ tab.displayText }}</a>
            </li>
        </ul>
        <div id="activeTab" class="border-end border-bottom border-start p-3">
            <slot></slot>
        </div>
        <div id="actions" class="mt-3">
            <a :href="cancelUrlWithFallback" class="btn btn-secondary">Cancel</a>
            <button class="btn btn-secondary ms-3" @click.prevent="go(-1)" v-if="canGoPrevious">
                Previous
            </button>
            <button class="btn btn-primary float-end" @click.prevent="go(+1)" v-if="canGoNext">
                Next
            </button>
            <button class="btn btn-primary float-end" @click.prevent="handleSubmit()" v-if="!canGoNext">
                Submit
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps, ref, defineEmits, computed } from 'vue';
import { Tab } from './TabLayout.types';

const props = withDefaults(defineProps<{
    headerLeftLabel: String,
    headerRightLabel: String,
    tabs: Tab[],
    modelValue: String,
    cancelButtonUrl: String
}>(), {
    tabs: () => []
});

const emit = defineEmits(["update-tab", "submit", "update:model-value"]);

var cancelUrlWithFallback = "dataupload.aspx?source=0";
if (props.cancelButtonUrl && props.cancelButtonUrl.length > 0) {
    cancelUrlWithFallback = props.cancelButtonUrl;
}

const canGoNext = computed(() => {
    return canGo(+1);
});

const canGoPrevious = computed(() => {
    return canGo(-1);
});

const maxTab = computed(() => {
    return props.tabs.length;
});

const activeTabIndex = computed(() => {
    for (let i = 0; i < props.tabs.length; i++) {
        if (isActive(props.tabs[i].componentName)) {
            return i;
        }
    }

    return -1;
});

function setActiveTab(componentName: String) {
    emit('update-tab', componentName);
}

function isActive(tabName: string): boolean {
    return tabName == props.modelValue;
}

function goToPage(tabIndex: number) {
    if (tabIndex < props.tabs.length) {
        setActiveTab(props.tabs[tabIndex].componentName);
    }
}

function go(deltaPage: number) {
    goToPage(Math.max(0, Math.min(props.maxTab, activeTabIndex + deltaPage)));
}

function canGo(deltaPage: number) {
    var newPage = activeTabIndex + deltaPage + 1;
    return newPage >= 1 && newPage <= maxTab;
}

function handleSubmit() {
    emit("submit");
}

</script>